import { useContext } from 'react';
import { ValidatorType } from '@vp/upload-and-print-validator';
import { ValidationContext, ValidationContextProps } from 'src/providers/ValidationContextProvider';

export function useValidationContext(): ValidationContextProps {
  return useContext(ValidationContext);
}

export function useIsPdfOnly(): boolean {
  const { validations, validationPlaceholders } = useValidationContext();

  const validationsToUse = validations ?? validationPlaceholders;
  const validationToUse = validationsToUse?.find(validation => validation.id === ValidatorType.CorruptValidator);
  return validationToUse && validationToUse?.details && (validationToUse?.details['pdfOnly'] ?? false);
}
